import React from 'react'

const ConfirmationDialog = ({ 
  isOpen, 
  onClose, 
  onConfirm, 
  title, 
  message, 
  confirmText = "Confirm", 
  cancelText = "Cancel",
  isSubmitting = false,
  type = "danger" // can be "danger", "warning", or "info"
}) => {
  if (!isOpen) return null

  const getButtonColor = () => {
    switch (type) {
      case "danger":
        return "bg-red-500 hover:bg-red-600"
      case "warning":
        return "bg-yellow-500 hover:bg-yellow-600"
      case "info":
        return "bg-blue-500 hover:bg-blue-600"
      default:
        return "bg-red-500 hover:bg-red-600"
    }
  }

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-30">
      <div className="bg-white rounded-lg shadow-lg p-6 w-full max-w-md relative">
        <button 
          className="absolute top-2 right-2 text-gray-400 hover:text-gray-700"
          onClick={onClose}
        >
          <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
        
        <h2 className="text-lg font-semibold mb-2">{title}</h2>
        <p className="text-gray-600 mb-6">{message}</p>

        <div className="flex justify-end gap-3">
          <button
            type="button"
            onClick={onClose}
            className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 hover:bg-gray-200 rounded-lg transition-colors"
            disabled={isSubmitting}
          >
            {cancelText}
          </button>
          <button
            type="button"
            onClick={onConfirm}
            className={`px-4 py-2 text-sm font-medium text-white ${getButtonColor()} rounded-lg transition-colors disabled:opacity-50 disabled:cursor-not-allowed`}
            disabled={isSubmitting}
          >
            {isSubmitting ? "Processing..." : confirmText}
          </button>
        </div>
      </div>
    </div>
  )
}

export default ConfirmationDialog 